import { Button } from "../Button/Button";
import {
  FooterGrid,
  FooterSide,
  FooterWrapper,
  LittleFooter,
} from "./Footer.elements";
import logoBlack from "../../Images/logoBlack.svg";

const Footer = () => {
  return (
    <>
      <FooterWrapper>
        <div className="res-cnt">
          <h1 data-aos="fade-left">Zainteresovani?</h1>
          <FooterGrid>
            <FooterSide>
              <h4 data-aos="fade-up">Kontaktirajte nas:</h4>
              <Button primary data-aos="fade-up">
                Kontakt
              </Button>
            </FooterSide>
            <FooterSide>
              <h4 data-aos="fade-up">Kupite nesto od nas:</h4>
              <Button white data-aos="fade-up">
                prodavnica
              </Button>
            </FooterSide>
          </FooterGrid>
        </div>
      </FooterWrapper>
      <LittleFooter>
        <img src={logoBlack} />
      </LittleFooter>
    </>
  );
};

export default Footer;
